/**
 * Raptor 监控模块
 */
// tslint:disable:trailing-comma

import BaseChannel from './base-channel';
import {
  OwlAddErrorOptions,
  StatErrorLevel,
  StatErrorCategory,
  RaptorSendParams,
} from '../constants';

export class RaptorChannel extends BaseChannel {
  available: boolean;

  constructor() {
    super();
    this.available = 'Owl' in window;
  }

  send(params: RaptorSendParams) {
    const {
      error = '',
      level = StatErrorLevel.Error,
      category = StatErrorCategory.JSError,
      tags,
    } = params;

    // @ts-ignore
    this.addError(error, {
      level,
      category,
      tags: {
        ...tags,
      },
    });
  }

  // @ts-ignore
  private addError(error: string, options: OwlAddErrorOptions) {
    if (!this.available) {
      return;
    }
    // @ts-ignore
    window.Owl.addError(error, options);
  }

  private getPageUrl(): string {
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  }
}
